import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiDownload, FiFileText, FiShare2 } = FiIcons;

const ActionBar = ({ onGenerateReport, onDownloadCSV, onShare, isShared }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white rounded-xl shadow-lg border border-gray-200 p-4"
    >
      <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="text-sm text-gray-600">
          <span className="font-medium">Export your results:</span> Save or share your incentive matches
        </div>
        
        <div className="flex items-center space-x-3">
          <button
            onClick={onDownloadCSV}
            className="inline-flex items-center space-x-2 px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors focus-ring"
          >
            <SafeIcon icon={FiDownload} className="w-4 h-4" />
            <span>Export CSV</span>
          </button>
          
          <button
            onClick={onShare}
            className="inline-flex items-center space-x-2 px-4 py-2 bg-primary-100 text-primary-700 rounded-lg hover:bg-primary-200 transition-colors focus-ring"
          >
            <SafeIcon icon={FiShare2} className="w-4 h-4" />
            <span>Share Summary</span>
          </button>
          
          {!isShared && (
            <button
              onClick={onGenerateReport}
              className="inline-flex items-center space-x-2 px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors focus-ring"
            >
              <SafeIcon icon={FiFileText} className="w-4 h-4" />
              <span>Download Full Report (PDF)</span>
            </button>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default ActionBar;